import { render, staticRenderFns } from "./module-settings-view.vue?vue&type=template&id=dbaad706"
import script from "./module-settings-view.vue?vue&type=script&lang=js"
export * from "./module-settings-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports